import * as React from 'react'
import styled, { css } from 'styled-components'

import { BREAKPOINTS, styles as S } from '@ulule/owl-kit-components/next'

type DiptychProps = {
  handlers?: {
    onClick: () => void
    onMouseEnter: () => void
    onMouseLeave: () => void
    onTouchStart: () => void
  }
  leftZone: React.ReactNode
  rightZone: React.ReactNode
  className?: string
}

const DiptychView = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 25px;
  min-width: 130px;
  position: relative;
  white-space: nowrap;

  @media screen and ${BREAKPOINTS.MOBILE_M} {
    min-width: 160px;
  }

  ${S.tooltip.Tooltip} {
    bottom: 50px;
  }
`

function DiptychComponent({
  handlers,
  leftZone,
  rightZone,
  className,
}: DiptychProps): React.ReactElement<DiptychProps> {
  return (
    <DiptychView
      onClick={handlers?.onClick}
      onMouseEnter={handlers?.onMouseEnter}
      onMouseLeave={handlers?.onMouseLeave}
      onTouchStart={handlers?.onTouchStart}
      className={className}
    >
      {leftZone}
      {rightZone}
    </DiptychView>
  )
}

export const Diptych = styled(DiptychComponent)``
